import yup from "src/utils/yup/extensionMethods";



const validateFormulaModal = (translate: Function) => yup.object().shape({
	formula: yup.string().required(translate("A fórmula é requerida"))
		.test("ValidateFormula",translate("A fórmula está inválida"), validateFormula)

});

const validateFormula = (value:string|any):boolean => {
	try {
		// verifica se existe um bin e um número lado a lado, sem operador entre eles.
		if (/(\])(\s*)([0-9])/g.test(value)) {
			return false;
		}
		if (/([0-9])(\s*)(\[)/g.test(value)) {
			return false;
		}
		// verifica se exite bind sem valor dentro
		if (/(\[\s*])/g.test(value)) {
			return false;
		}
		// verifica se existem binds lado a lado, sem operador entre eles
		let val = value.replace(/\s\n|\s/g, "");
		if (val.includes("][")) {
			return false;
		}
		// verifica se, após trocar os binds, existem binds inválidos
		val = val.replace(/\[(.*?)\]/g, "1");
		if (val.includes("[") || val.includes("]")) {
			return false;
		}
		// verifica se a expressão é uma expressão matemática válida
		// eslint-disable-next-line no-eval
		if (Number.isNaN(parseFloat(eval(val)))) {
			return false;
		}
		return true;
	} catch (e) {
		return false;
	}
};


export default validateFormulaModal;
